import { createRouter, createWebHashHistory } from "vue-router";
import Login from "@/Pages/Login.vue";
import Dashboard from "@/Pages/Dashboard/Dashboard.vue";
import ProjectsIndex from "@/Pages/Projects/Index/Index.vue";
import ProjectsCreate from "@/Pages/Projects/Create/Create.vue";
import ProjectsEdit from "@/Pages/Projects/Edit/Edit.vue";
import OneClick from "@/Pages/OneClick/OneClick.vue";
import PublicationsIndex from "@/Pages/Publications/Index/Index.vue";
import PersonasIndex from "@/Pages/Personas/Index/Index.vue";
import PersonasCreate from "@/Pages/Personas/Create/Create.vue";
import PersonasEdit from "@/Pages/Personas/Edit/Edit.vue";
import LinkingAutomaticPosts from "@/Pages/Linking/Posts.vue";
import LinkingAutomaticPages from "@/Pages/Linking/Pages.vue";
import LinkingManual from "@/Pages/Linking/Manual.vue";
import SettingsApi from "@/Pages/Settings/Api/Show.vue";
import GlobalSystems from "@Pages/Settings/GlobalSystems/Show.vue";
import Amazon from "@Pages/Settings/Amazon/Show.vue";
import ImageGenerator from "@/Pages/ImageGenerator/ImageGenerator.vue";
import SingleModeCreate from "@Pages/SingleMode/Create.vue";
import SingleModeShow from "@Pages/SingleMode/Show.vue";
import UIShow from "@/Pages/UI/Show.vue";
import { isLoggedIn, isTrialEnded } from "./auth";

const routes = [
    {
        name: "login",
        path: "/login",
        component: Login,
        meta: {
            layout: "guest",
        },
    },
    {
        name: "dashboard",
        path: "/",
        component: Dashboard,
    },
    {
        name: "projects.index",
        path: "/projects",
        component: ProjectsIndex,
    },
    {
        name: "projects.create",
        path: "/projects/create/:type/:postType/:style?",
        component: ProjectsCreate,
    },
    {
        name: "projects.edit",
        path: "/projects/edit/:id",
        component: ProjectsEdit,
    },
    {
        name: "one-click",
        path: "/one-click",
        component: OneClick,
    },
    {
        name: "image-generator",
        path: "/image-generator",
        component: ImageGenerator,
    },
    {
        name: "single-mode.create",
        path: "/single-mode/create",
        component: SingleModeCreate,
    },
    {
        name: "single-mode.show",
        path: "/single-mode/:id",
        component: SingleModeShow,
    },
    {
        name: "publications.index",
        path: "/projects/:id/publications",
        component: PublicationsIndex,
    },
    {
        name: "personas.index",
        path: "/personas",
        component: PersonasIndex,
    },
    {
        name: "personas.create",
        path: "/personas/create",
        component: PersonasCreate,
    },
    {
        name: "personas.edit",
        path: "/personas/:id",
        component: PersonasEdit,
    },
    {
        name: "linking.automatic.posts",
        path: "/linking/automatic/posts",
        component: LinkingAutomaticPosts,
    },
    {
        name: "linking.automatic.pages",
        path: "/linking/automatic/pages",
        component: LinkingAutomaticPages,
    },
    {
        name: "linking.manual.index",
        path: "/linking/manual",
        component: LinkingManual,
    },
    {
        name: "settings.global-systems",
        path: "/settings/global-systems",
        component: GlobalSystems,
    },
    {
        name: "settings.amazon",
        path: "/settings/amazon",
        component: Amazon,
    },
    {
        name: "settings",
        path: "/settings/api",
        component: SettingsApi,
    },
    {
        name: "ui",
        path: "/ui",
        component: UIShow,
        meta: {
            layout: "none",
        },
    },
    {
        name: "error",
        path: "/:catchAll(.*)",
        redirect: "/",
    },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach(async (to, from) => {
    if (to.name === "login" && isLoggedIn()) {
        return { name: "dashboard" };
    } else if (to.name !== "login" && !isLoggedIn()) {
        return { name: "login" };
    }

    if (["dashboard", "settings", "login"].indexOf(to.name) === -1 && isTrialEnded()) {
        return { name: "dashboard", query: { trial: "ended", _r: Date.now() } };
    }
});

export default router;
